var _defs, _path, _ellipse, _ellipse2, _ellipse3, _path2, _path3, _path4, _path5, _path6, _path7, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdc3c9;}.cls-2{fill:#3c4650;}.cls-3,.cls-5,.cls-6,.cls-8,.cls-9{fill:none;}.cls-3{stroke:#212c38;}.cls-3,.cls-5,.cls-6,.cls-8{stroke-linecap:round;}.cls-3,.cls-5,.cls-6,.cls-9{stroke-miterlimit:10;}.cls-4{fill:#dfe5e9;}.cls-5,.cls-6,.cls-8,.cls-9{stroke:#3c4650;}.cls-6{stroke-width:0.75px;}.cls-7{fill:#ffaa96;}.cls-8{stroke-linejoin:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.71,56.21c0-3.72,3.67-6.74,8.2-6.74H169.54c4.53,0,8.2,3,8.2,6.74V63c0,4.88-3.11,6.49-8.2,6.49H44.76c-4.45,0-8-1.82-8-4.64S36.71,56.21,36.71,56.21Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 49.22,
    cy: 53.91,
    rx: 1.59,
    ry: 1.43
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 54.77,
    cy: 53.91,
    rx: 1.59,
    ry: 1.43
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 60.32,
    cy: 53.91,
    rx: 1.59,
    ry: 1.43
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M196,86.46V147.3a6,6,0,0,1-5.9,6H105"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M173.75,171.6c-1.88-2.17-4.1-4.94-5.28-6.33-2.47-3.08-4.27-4.39-8.38-4.39H25.69c-4.12,0-5.92,1.31-8.38,4.39-1.18,1.39-3.4,4.16-5.28,6.33s-1.77,4.66,4.23,4.66H169.53C175.52,176.26,175.63,173.78,173.75,171.6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M204,171.6c-1.88-2.17-9.56-9.91-9.56-9.91H170.87L180,171.6s3.79,4.66,9.79,4.66h10C205.75,176.26,205.85,173.78,204,171.6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.07,33.67H23.83a6,6,0,0,0-5.9,6V142.54a6,6,0,0,0,5.9,6H188.07a6,6,0,0,0,5.9-6V39.68A6,6,0,0,0,188.07,33.67Zm-3.72,102.41a5,5,0,0,1-5,5.07H33.59a5,5,0,0,1-5-5.07V49.27a5,5,0,0,1,5-5.07H179.37a5,5,0,0,1,5,5.07Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43,153.51H26.29a6,6,0,0,1-5.9-6V44.65a6,6,0,0,1,5.9-6H190.53a6,6,0,0,1,5.9,6v22"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M213.17,176c-2.57-3-5.61-6.76-7.22-8.66-3.37-4.21-5.83-6-11.47-6h-173c-5.63,0-8.09,1.79-11.47,6C8.44,169.19,5.39,173,2.83,176s-2.43,6.37,5.78,6.37H207.39C215.6,182.33,215.74,178.92,213.17,176Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 41.06,
    y1: 87.83,
    x2: 52.09,
    y2: 87.83
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 41.06,
    y1: 90.75,
    x2: 50.33,
    y2: 90.75
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 41.06,
    y1: 93.67,
    x2: 52.09,
    y2: 93.67
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 41.06,
    y1: 119.43,
    x2: 52.09,
    y2: 119.43
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 41.06,
    y1: 122.35,
    x2: 50.33,
    y2: 122.35
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 41.06,
    y1: 96.6,
    x2: 48.92,
    y2: 96.6
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 41.06,
    y1: 99.52,
    x2: 52.09,
    y2: 99.52
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 41.06,
    y1: 102.44,
    x2: 50.33,
    y2: 102.44
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 41.06,
    y1: 105.37,
    x2: 52.09,
    y2: 105.37
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 41.06,
    y1: 108.29,
    x2: 47.15,
    y2: 108.29
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 40.48,
    y1: 114.6,
    x2: 61.8,
    y2: 114.6
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 71.14,
    y1: 73.77,
    x2: 71.14,
    y2: 125.28
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M45.08,81.25a1.6,1.6,0,1,1,1.6-1.6A1.59,1.59,0,0,1,45.08,81.25Zm0-2.7a1.1,1.1,0,1,0,1.1,1.1A1.11,1.11,0,0,0,45.08,78.55Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M45.83,83.88H44.26a.26.26,0,0,1-.25-.21l-.14-1-.21-.11-.78.6a.26.26,0,0,1-.32,0l-1.07-1.1a.26.26,0,0,1,0-.32l.64-.82a.13.13,0,0,1,0-.11l-1-.14a.24.24,0,0,1-.21-.25V78.87a.26.26,0,0,1,.21-.25l1-.14.11-.21-.64-.85a.23.23,0,0,1,0-.32L42.63,76a.26.26,0,0,1,.32,0l.78.6s.11,0,.14-.07l.14-1a.24.24,0,0,1,.25-.21h1.56a.26.26,0,0,1,.25.21l.14,1,.28.11.71-.57a.26.26,0,0,1,.32,0l1.07,1.1a.26.26,0,0,1,0,.32l-.57.75a.5.5,0,0,1,.07.21l.92.11a.24.24,0,0,1,.21.25v1.56a.26.26,0,0,1-.21.25l-.92.14c0,.11-.07.18-.11.28l.57.75a.22.22,0,0,1,0,.32l-1.1,1.07a.26.26,0,0,1-.32,0l-.78-.6c-.07,0-.11,0-.14.07l-.14,1A.24.24,0,0,1,45.83,83.88Zm-1.35-.5h1.14l.11-.89a.23.23,0,0,1,.18-.21,2.7,2.7,0,0,0,.39-.14.22.22,0,0,1,.25,0l.75.57L48.1,82l-.53-.71a.22.22,0,0,1,0-.25c.07-.14.14-.32.21-.5a.36.36,0,0,1,.21-.18l.89-.14V79L48,78.94a.23.23,0,0,1-.21-.18,2.17,2.17,0,0,0-.18-.43.17.17,0,0,1,0-.25l.53-.71-.78-.82-.71.53a.22.22,0,0,1-.25,0l-.46-.21c-.11,0-.14-.11-.18-.21l-.14-.89H44.48l-.11.92a.23.23,0,0,1-.18.21,3.68,3.68,0,0,0-.36.14.27.27,0,0,1-.28,0l-.75-.57-.78.78.53.75a.22.22,0,0,1,0,.25,2.17,2.17,0,0,0-.18.43.23.23,0,0,1-.21.18l-1,.14v1.14l1,.14a.23.23,0,0,1,.21.18,2.45,2.45,0,0,0,.14.36.22.22,0,0,1,0,.25l-.57.78.78.82.75-.6a.22.22,0,0,1,.25,0,2.17,2.17,0,0,0,.43.18.36.36,0,0,1,.18.21Zm4.58-3Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M137.52,48H43.69c-5.08,0-8,3.22-8,8.15v71a8.15,8.15,0,0,0,8,8.25h126a8.15,8.15,0,0,0,8-8.25v-39"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.11,92.07c-.93,0-1.68-.44-1.68-1V88.58c0-.54.75-1,1.68-1h35.73c.93,0,1.68.44,1.68,1V91.1c0,.54-.75,1-1.68,1Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.51,92.07c-.93,0-1.69-.44-1.69-1V88.58c0-.54.76-1,1.69-1h35.75c.93,0,1.69.44,1.69,1V91.1c0,.54-.75,1-1.69,1Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.5,102.33c-.93,0-1.69-.44-1.69-1V98.84c0-.54.76-1,1.69-1h35.75c.93,0,1.69.44,1.69,1v2.52c0,.54-.75,1-1.69,1Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M81.37,102.33c-.83,0-1.5-.39-1.5-.87V98.74c0-.48.67-.87,1.5-.87h36c.89,0,1.61.38,1.61.81,0,1,0,2.43,0,2.75"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M81.09,112.47a1.26,1.26,0,0,1-1.21-1.3V109.3a1.26,1.26,0,0,1,1.21-1.3H93.35a1.26,1.26,0,0,1,1.21,1.3v1.87a1.26,1.26,0,0,1-1.21,1.3Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M89.84,87.6h-8c-1.1,0-2,.47-2,1V91c0,.58.9,1,2,1h35c1.18,0,2.15-.46,2.15-1V88.17"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M136.77,87.6h21.41c1.09,0,2,.46,2,1V91c0,.56-.89,1-2,1H123.55c-1.17,0-2.13-.45-2.13-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.336ef8ddea85f8ab18cc344cac118e2c.svg";
export { ForwardRef as ReactComponent };